/**
 * @generated SignedSource<<7de5f0419501ce87eac3f3310079c941>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LoadSchoolsForDropdownsQuery$variables = {
  isActive?: boolean | null | undefined;
  orderBy?: string | null | undefined;
  searchTerm?: string | null | undefined;
};
export type LoadSchoolsForDropdownsQuery$data = {
  readonly schools: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly archived: boolean;
        readonly id: string;
        readonly name: string;
      } | null | undefined;
    } | null | undefined>;
  } | null | undefined;
};
export type LoadSchoolsForDropdownsQuery = {
  response: LoadSchoolsForDropdownsQuery$data;
  variables: LoadSchoolsForDropdownsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isActive"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchTerm"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "isActive",
        "variableName": "isActive"
      },
      {
        "kind": "Variable",
        "name": "orderBy",
        "variableName": "orderBy"
      },
      {
        "kind": "Variable",
        "name": "searchTerm",
        "variableName": "searchTerm"
      }
    ],
    "concreteType": "SchoolNodeConnection",
    "kind": "LinkedField",
    "name": "schools",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SchoolNodeEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SchoolNode",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "archived",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__id",
            "storageKey": null
          }
        ]
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "LoadSchoolsForDropdownsQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "LoadSchoolsForDropdownsQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "5f26f4b015457ab64d3cb78194abdaec",
    "id": null,
    "metadata": {},
    "name": "LoadSchoolsForDropdownsQuery",
    "operationKind": "query",
    "text": "query LoadSchoolsForDropdownsQuery(\n  $searchTerm: String\n  $orderBy: String\n  $isActive: Boolean\n) {\n  schools(orderBy: $orderBy, searchTerm: $searchTerm, isActive: $isActive) {\n    edges {\n      node {\n        id\n        name\n        archived\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d6d81c3007e660ef5435ec9e6d746110";

export default node;
